import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('@ribera-web/satisfaction-survey-feature').then(
        (m) => m.satisfactionSurveyFeatureRoutes
      ),
  },
];
